export const routes = [
    {
        path: '/',
        redirect: "/home",
        meta: {
            show: false, //判断是否展示菜单栏
        },
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/pages/home'),
        meta: {
            title: "门户",
            show: false,
        },
    }
]


// WEBPACK FOOTER //
// ./src/router/router.config.js